<template>
  <div class="content">
    <transition name="fade">
      <add-permission-modal
        v-if="isModalOpen"
        :roles="roles"
        :preselected-role="selectedRole"
        @close="closeModal"
      />
    </transition>

    <div class="join join--col join--lg">
      <header>
        <h1>Права доступа</h1>
      </header>

      <form class="form" ref="form">
        <div class="form__group form__group--gap-md form__group--flex-end">
          <t-text
            label="Поиск по UUID, ФИО или E-mail"
            v-model="search"
            @update:modelValue="onSearchInput"
          />
          <button class="btn btn--primary" type="button" @click="onResetAll">Сбросить</button>
          <button class="btn btn--outline-primary" type="button" @click="openModal">Добавить</button>
        </div>
      </form>

      <div class="content content--aside">
        <permissions-sidebar
          :roles="roles"
          v-model="selectedRole"
          @update:model-value="onSelectRole"
        />

        <div class="join join--col join--center join--lg">
          <permissions-table
            :permissions="permissions"
            @delete="deletePermission"
          />

          <t-paginate
            v-if="pagination.pages > 1"
            :pages="pagination.pages"
            :current="pagination.page"
            @change-page="onChangePage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { TText, TPaginate } from '@shared/ui'
import { useDebounce, useModal } from '@shared/lib'
import { usePermissions } from '../model/usePermissions'

import PermissionsSidebar from './PermissionsSidebar'
import PermissionsTable from './PermissionsTable'
import AddPermissionModal from './AddPermissionModal'

const { roles, permissions, pagination, updateQuery, deletePermission, fetchPermissionsList } = usePermissions()
const { isModalOpen, openModal, closeModal } = useModal()

const route = useRoute()
const router = useRouter()

const search = ref(route.query.fulltext || '')
const selectedRole = ref(route.query.role || null)

const onSelectRole = (role) => updateQuery({ role: role || undefined, page: null })
const onChangePage = (page) => updateQuery({ page: page })
const onSearchInput = useDebounce((search) => updateQuery({ fulltext: search || undefined, page: null }))

const onResetAll = () => {
  search.value = ''
  selectedRole.value = null
  router.replace({ query: {} })
}
</script>